(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedLocationDialogController', MedLocationDialogController);

    MedLocationDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'MedLocation', 'Medication'];

    function MedLocationDialogController ($timeout, $scope, $uibModalInstance, entity, MedLocation, Medication) {
        var vm = this;

        vm.medLocation = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.medLocation.id !== null) {
                MedLocation.update(vm.medLocation, onSaveSuccess, onSaveError);
            } else {
                MedLocation.save(vm.medLocation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:medLocationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
